/* Reveal page — Waved vs Non-waved blind tasting.
   The batch→treatment rule lives ONLY here (never printed as a rule on the page):
   batch 1–49 = Non-waved, 50–99 = Waved. */
(function () {
  var root = document.querySelector('[data-reveal-form]');
  if (!root) return;

  var ENDPOINT = root.getAttribute('data-endpoint');
  var AMEND    = ENDPOINT.replace(/\/submit\/?$/, '/amend');
  var form    = root.querySelector('[data-form]');
  var result  = root.querySelector('[data-result]');
  var errorEl = form.querySelector('[data-error]');
  var again   = form.querySelector('[data-again]');
  var submit  = form.querySelector('[data-submit]');
  var batch1  = form.querySelector('[data-batch="1"]');
  var batch2  = form.querySelector('[data-batch="2"]');
  var prefSpan1 = form.querySelector('[data-pref="1"]');
  var prefSpan2 = form.querySelector('[data-pref="2"]');
  var savedEl   = result.querySelector('[data-saved]');
  var addnoteEl = result.querySelector('[data-addnote]');
  var extraEl   = result.querySelector('[data-extra]');
  var addedEl   = result.querySelector('[data-added]');
  var savedId   = null;

  // --- treatment for a batch number (the secret rule) ---
  function treatment(n) {
    if (n >= 1 && n <= 49) return 'Non-waved';
    if (n >= 50 && n <= 99) return 'Waved';
    return null;
  }

  // Parse a batch input → integer 1–99, or null if blank/out-of-range.
  function parseBatch(input) {
    var raw = (input.value || '').trim();
    if (raw === '') return null;
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 1 || n > 99 || String(n) !== raw.replace(/^0+(?=\d)/, '')) return NaN;
    return n;
  }

  // Live-relabel the preference pills with the batch numbers the taster entered.
  function relabelPrefs() {
    var b1 = (batch1.value || '').trim();
    var b2 = (batch2.value || '').trim();
    prefSpan1.textContent = b1 ? 'Batch ' + b1 : 'Sample 1';
    prefSpan2.textContent = b2 ? 'Batch ' + b2 : 'Sample 2';
  }
  batch1.addEventListener('input', relabelPrefs);
  batch2.addEventListener('input', relabelPrefs);

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function clearError() {
    errorEl.hidden = true;
    form.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });
  }

  function preferredLabel(val, b1, b2) {
    if (val === 'sample1') return b1 != null ? 'Batch ' + b1 : 'Sample 1';
    if (val === 'sample2') return b2 != null ? 'Batch ' + b2 : 'Sample 2';
    if (val === 'none') return 'No preference';
    return '';
  }

  function renderResult(entries) {
    var cards = result.querySelector('[data-result-cards]');
    cards.innerHTML = '';
    entries.forEach(function (e) {
      var waved = e.treatment === 'Waved';
      var li = document.createElement('li');
      li.className = 'reveal__card';

      var head = document.createElement('div');
      head.className = 'reveal__cardhead';
      var b = document.createElement('b');
      b.textContent = 'Batch ' + e.batch;
      var badge = document.createElement('span');
      badge.className = 'reveal__badge ' + (waved ? 'reveal__badge--waved' : 'reveal__badge--plain');
      badge.textContent = e.treatment;
      head.appendChild(b);
      head.appendChild(badge);
      li.appendChild(head);

      // Recap what they wrote for this sample.
      if (e.note) {
        var note = document.createElement('p');
        note.className = 'reveal__cardnote';
        var lbl = document.createElement('span');
        lbl.textContent = 'Your notes: ';
        note.appendChild(lbl);
        note.appendChild(document.createTextNode(e.note));
        li.appendChild(note);
      }
      cards.appendChild(li);
    });

    // Reset the post-reveal "anything else" box for a fresh reveal.
    addnoteEl.hidden = true;
    addedEl.hidden = true;
    extraEl.value = '';
    extraEl.removeAttribute('readonly');
    var addBtn = result.querySelector('[data-addnote-save]');
    if (addBtn) addBtn.disabled = false;

    form.hidden = true;
    result.hidden = false;
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Post-reveal: append one more thought to the same submission (by id).
  result.querySelector('[data-addnote-save]').addEventListener('click', function () {
    var note = (extraEl.value || '').trim();
    if (!note || !savedId) return;
    var btn = this;
    btn.disabled = true;
    fetch(AMEND, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: savedId, note: note })
    }).then(function (r) {
      if (r.ok) { addedEl.hidden = false; extraEl.setAttribute('readonly', ''); }
      else { btn.disabled = false; }
    }).catch(function () { btn.disabled = false; });
  });

  // Back to the form to reveal / submit again.
  result.querySelector('[data-edit]').addEventListener('click', function () {
    result.hidden = true;
    form.hidden = false;
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    clearError();

    var revealOnly = again.checked;
    var b1 = parseBatch(batch1);
    var b2 = parseBatch(batch2);

    // Range/format check on whatever was typed.
    if (isNaN(b1)) { batch1.classList.add('is-invalid'); return showError('Batch numbers must be between 1 and 99.'); }
    if (isNaN(b2)) { batch2.classList.add('is-invalid'); return showError('Batch numbers must be between 1 and 99.'); }
    if (b1 == null && b2 == null) {
      batch1.classList.add('is-invalid');
      return showError('Enter at least one batch number to reveal.');
    }

    // In normal mode, tasting notes are required for each sample that has a batch entered.
    if (!revealOnly) {
      var notes1El = form.querySelector('[name="notes1"]');
      var notes2El = form.querySelector('[name="notes2"]');
      if (b1 != null && !notes1El.value.trim()) {
        notes1El.classList.add('is-invalid');
        return showError('Please add your tasting notes for Batch ' + b1 + '.');
      }
      if (b2 != null && !notes2El.value.trim()) {
        notes2El.classList.add('is-invalid');
        return showError('Please add your tasting notes for Batch ' + b2 + '.');
      }
    }

    // Build the reveal (with a recap of what they wrote for each sample).
    var notes1Val = (form.querySelector('[name="notes1"]').value || '').trim();
    var notes2Val = (form.querySelector('[name="notes2"]').value || '').trim();
    var entries = [];
    if (b1 != null) entries.push({ batch: b1, treatment: treatment(b1), note: notes1Val });
    if (b2 != null) entries.push({ batch: b2, treatment: treatment(b2), note: notes2Val });

    var prefRadio = form.querySelector('input[name="preferred"]:checked');
    var prefVal = prefRadio ? prefRadio.value : '';
    var payload = {
      submitted_at: new Date().toISOString(),
      reveal_only: revealOnly,
      batch1: b1, batch1_treatment: b1 != null ? treatment(b1) : '',
      batch2: b2, batch2_treatment: b2 != null ? treatment(b2) : '',
      notes1: (form.querySelector('[name="notes1"]').value || '').trim(),
      notes2: (form.querySelector('[name="notes2"]').value || '').trim(),
      preferred: prefVal,
      preferred_label: preferredLabel(prefVal, b1, b2),
      notes: (form.querySelector('[name="notes"]').value || '').trim()
    };

    // Reveal immediately — never blocked on the network.
    renderResult(entries);

    // Decide whether to persist. Reveal-only submissions are skipped UNLESS the taster
    // actually typed something (so we never lose accidental input), and are tagged reveal_only.
    var hasContent = payload.notes1 || payload.notes2 || payload.notes || payload.preferred;
    savedId = null;
    savedEl.hidden = true;
    if (revealOnly && !hasContent) return;

    // Fire-and-forget POST; KV on the Worker is the durable store. On success we keep the
    // id so the post-reveal note can be appended to the same submission.
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.id) {
          savedId = j.id;
          savedEl.hidden = false;
          addnoteEl.hidden = false;
        }
      }).catch(function () { /* reveal already shown; nothing to do */ });
  });

  relabelPrefs();
})();
